import React from "react"
import { Tooltip } from "@mui/material"
import InfoIcon from "@mui/icons-material/Info"

/**
 * Info icon with a hover tooltip used to guide CMS users.
 *
 * Matches the platform convention (filled `InfoIcon`, `fontSize="small"`, default
 * MUI tooltip) already used by AppTextField / AppSelect / file-upload fields, so
 * info icons look the same everywhere. `title` may contain "\n" for line breaks.
 */
const InfoTooltip = ({ title, placement = "top", sx = {} }) => {
  if (!title) return null

  return (
    <Tooltip
      title={title}
      placement={placement}
      componentsProps={{ tooltip: { sx: { whiteSpace: "pre-line", maxWidth: 300 } } }}>
      <InfoIcon
        fontSize="small"
        sx={{ cursor: "help", verticalAlign: "middle", color: "text.secondary", ...sx }}
      />
    </Tooltip>
  )
}

export default InfoTooltip
